export class Address {
  Found: boolean;
  City: string;
  Street: string;
  Municipality: string;
  Province: string;
  NEN5825: string;
}
